/*!
 * jQuery Custom-form-elements plugin
 * Author: Globalia
 * Licensed under the WTFPL license
 */

// Custom Select
// --------------------------------------------------

( function( global ) { // eslint-disable-line

    var pluginName = 'grFormNormalize';

    //  Constructor
    // --------------------------------------------------------------------------

    function grFormNormalize(selector) {
        // Create global references
        this.selector = typeof selector === 'string' ? document.querySelector(selector) : selector;

        // Init
        this.init();
    }

    //  Methods
    // --------------------------------------------------------------------------

    grFormNormalize.prototype.init = function init() {
        this.normelizeHubspot();

        // Re-initialize form selects
        var selects = this.selector.querySelectorAll('select');

        if ( selects.length && global.plugins.grFormSelect !== undefined ) {
            var globIndex;
            var index = -1;

            if ( global.grFormSelect !== undefined ) {
                globIndex = Object.keys(global.grFormSelect.instances).length;
            } else {
                global.grFormSelect = { instances: {} };
                globIndex = -1;
            }

            while (selects[++index]) {
                global.grFormSelect.instances[globIndex] = new global.plugins.grFormSelect(selects[index]);
            }
        }

        // Re-initialize form file inputs
        var fileInputs = this.selector.querySelectorAll('input[type="file"]');

        if ( fileInputs.length && global.plugins.grFormUpload !== undefined ) {
            var globIndex;
            var index = -1;

            if ( global.grFormUpload !== undefined ) {
                globIndex = Object.keys(global.grFormUpload.instances).length;
            } else {
                global.grFormUpload = { instances: {} };
                globIndex = -1;
            }

            while (fileInputs[++index]) {
                global.grFormUpload.instances[globIndex] = new global.plugins.grFormUpload(fileInputs[index]);
            }
        }

        global.methods.toggleAttributeValue(this.selector, 'gr-form-normalize', 'ready');
        if (global.verbose) console.log(pluginName + ': ready');
    }

    grFormNormalize.prototype.normelizeHubspot = function mouseclickHandler(event) {
        if (global.verbose) console.log(pluginName + '(' + this.selector.id + '): processing start');
        global.methods.toggleAttributeValue(this.selector, 'gr-form-normalize', 'processing');

        // Make sure that checkbox and radio are positionned before their label
        var checkboxes = this.selector.querySelectorAll('input[type="checkbox"]');

        for (var i = checkboxes.length - 1; i >= 0; i--) {
            var label = this.selector.querySelector('label[for="' + checkboxes[i].getAttribute('id') + '"].hs-form-booleancheckbox-display');
            // console.log(this.selector.querySelector('label[for="' + checkboxes[i].getAttribute('id') + '"]'));
            checkboxes[i].parentNode.parentNode.insertBefore(checkboxes[i], label);
        }

        var listcheckboxes = this.selector.querySelectorAll('.inputs-list.multi-container input[type="checkbox"]');

        for (var i = listcheckboxes.length - 1; i >= 0; i--) {
            var label = this.selector.querySelector('label[for="' + listcheckboxes[i].getAttribute('id') + '"].hs-form-checkbox-display');
            // console.log(this.selector.querySelector('label[for="' + listcheckboxes[i].getAttribute('id') + '"]'));
            listcheckboxes[i].parentNode.insertBefore(listcheckboxes[i], label);
        }

        var radios = this.selector.querySelectorAll('input[type="radio"]');

        for (var i = radios.length - 1; i >= 0; i--) {
            var label = this.selector.querySelector('label[for="' + radios[i].getAttribute('id') + '"].hs-form-radio-display');

            radios[i].parentNode.parentNode.insertBefore(radios[i], label);
        }

        // Make sure that file input labels are positionned after
        var fileInputs = this.selector.querySelectorAll('input[type="file"]');

        for (var i = fileInputs.length - 1; i >= 0; i--) {
            var label = this.selector.querySelector('label[for="' + fileInputs[i].getAttribute('id') + '"]');

            fileInputs[i].parentNode.insertBefore(label, fileInputs[i].nextSibling);
        }

        global.methods.removeAttributeValue(this.selector, 'gr-form-normalize', 'processing');
        if (global.verbose) console.log(pluginName + ': processed');
    }

    // Destroy - remove listeners to prevent from memory leak
    grFormNormalize.prototype.destroy = function destroy() {
        global.methods.removeAttributeValue(this.selector, 'gr-form-normalize', 'ready processing');
        if (global.verbose) console.log(pluginName + ': destroyed');
    };

    //  Auto-Instantiation
    // --------------------------------------------------------------------------

    var all = {}, index;

    window.addEventListener('load', function () {
        if (document.querySelectorAll('[gr-form-normalize]').length) {
            window.groots.grFormNormalize = { instances: {} };
            all = document.querySelectorAll('[gr-form-normalize]');
            index = -1;
            while (all[++index])
                global.grFormNormalize.instances[index] = new grFormNormalize(all[index]);
        }
    }, false);

    // Export to CommonJS
    if (typeof module !== 'undefined' && module.exports) module.exports = grFormNormalize;
    // Export to Browser
    else global[pluginName] = grFormNormalize; // eslint-disable-line

}( window.groots ));
